import youTubePlayer from "youtube-player";

export const video = {
	init: ( selector = '.video-cover-wrapper' ) => {
		document.querySelectorAll( selector ).forEach( ( videoContainer ) => {
			const cover = videoContainer.querySelector( '.cover' );
			const embedContainer = videoContainer.querySelector( '.wp-block-embed' );
			const isEmbed = embedContainer !== null;
			let isYoutube = false;
			if ( isEmbed ) {
				isYoutube = embedContainer.classList.contains( 'wp-block-embed-youtube' );
			}
			if ( cover ) {
				cover.addEventListener( 'click', () => {
					videoContainer.classList.add( 'cover-clicked' );
					if ( isYoutube ) {
						const player = youTubePlayer( embedContainer.querySelector( 'iframe' ) );
						player.playVideo();
					} else {
						const player = videoContainer.querySelector( 'video' );
						if ( player ) {
							player.play();
						}
					}
				} );
			}
		} );
	}
}